/**
 * storageService.js
 *
 * Thin wrapper around localStorage. Core code never touches
 * window.localStorage directly — everything goes through here so the
 * storage strategy (localStorage vs sessionStorage vs memory) can be
 * swapped in one place.
 */

const SESSION_KEY = 'erp.session';

export const storageService = {
  saveSession(session) {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    localStorage.setItem('PID', session.user_data['PID']);
    localStorage.setItem('ProfileData', JSON.stringify(session.user_data));
  },

  loadSession() {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  clearSession() {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem('PID');
    localStorage.removeItem('ProfileData');
  },
};
